<a class="teaser-wrapper" [class.new-item]="markAsNew" [routerLink]="url" tabindex="0">
  <mat-card class="teaser" [ngClass]="{ highlight: highlight, 'top-of-the-list': topOfTheList }">
    <div
      class="teaser__image__wrapper"
      [class.teaser__image__wrapper--placeholder]="!imageUrl"
      [style.background-image]="backgroundImage ? 'url(' + backgroundImage + ')' : null">
      @if (imageUrl) {
      <img [src]="imageUrl" [alt]="cardTitle" class="teaser__image" />
      } @else { @if (imagePlaceholder) {
      <div
        class="teaser__image"
        [ngClass]="{
          'teaser__image--placeholder': !imagePlaceholderFullsize,
          'teaser__image--fullsize-placeholder': imagePlaceholderFullsize
        }"
        [style.background-image]="'url(' + imagePlaceholder + ')'"></div>
      } @else {
      <mat-icon class="teaser__image--placeholder-icon">{{ imagePlaceholderIcon }}</mat-icon>
      } }
    </div>
    @if (showSubtitleArea) {
    <mat-card-subtitle>
      <div class="subtitle__flex">
        <ng-content select="[card-subtitle]"></ng-content>
        @if (startup) {
        <span class="subtitle__divider"></span>
        <div class="subtitle__startupitem" #startupFlag>
          <mat-icon
            matTooltip="Startup"
            matTooltipClass="bau365-tooltip teaser__startuptooltip"
            matTooltipPosition="above"
            #tooltip="matTooltip"
            (mouseenter)="tooltip.toggle()"
            (mouseleave)="tooltip.toggle()"
            (touchstart)="tooltip.toggle()"
            (touchend)="tooltip.toggle()"
            i18n-matTooltip="@@featureSearch-itemTeaserCard-startup-tooltip"
            [class.directory__startuptooltiphidden]="!hideStartupText"
            >rocket_launch</mat-icon
          >
          <span i18n="@@featureSearch-itemTeaserCard-startup" class="mat-caption">Startup</span>
        </div>
        }
      </div>
    </mat-card-subtitle>
    }
    <mat-card-title class="teaser__title" #title>{{ cardTitle }}</mat-card-title>
    <mat-card-content class="teaser__content content">
      <ng-content select="[card-content]"></ng-content>
    </mat-card-content>
    <mat-card-actions class="teaser__actions">
      <ng-content select="[card-actions]"></ng-content>
    </mat-card-actions>
  </mat-card>
</a>
